export const FALLBACK_FONT = `,-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif`
